module.exports = __webpack_public_path__ + "static/media/SleepConsultation.c685d540.png";